export enum DiagramType {
  GRAPH = 'GRAPH',
  WAYTIME = 'WAYTIME',
}
